<template>

    <Dialog :dialog="dlg" :loading="dlg.loading">        
        <template v-slot:content>
            <v-form ref="form">
                <v-card flat>
                    <v-card-text class="pt-2">
                         <FormRow label="Titel">
                             <TextField :rules="dlg.ruleMandatory" v-model="dlg.name"></TextField>
                         </FormRow>
                    </v-card-text>
                </v-card>

            </v-form>
        </template>

    </Dialog>

</template>

<script setup>

    import Dialog from '@shared/ui/dialogs/ModelDialog'
    import clsDialogModel from '@cls/clsDialogModel'
    import FormRow from '@controls/forms/FormRow'
    import { computed, ref } from 'vue'
    import TextField from '@controls/input/TextField'
    import {activitytype as api} from '@app/api'
    import {activitytype as list} from '@app/list'
    import Constants from '@app/consts'
    let form=ref(null)

    const defaultCategory  = Constants.planning.activity.categories.PROJECT;
    /**
     * For an alert dialog, we do not need a model. Just use the dialog.
     */
    class DialogModelActivityType extends clsDialogModel {
        name = "";
        id_category = defaultCategory;
        get fillable() { return ['name', 'id_category']; }

        // load does just fill the model with default value - empty. No server interaction.
        async load(params) {
            var result = await api.load(params.id);
            return result.data;
        }
        // Set the category to the provided category, or the default category.
        async create(params, extraData) {
            return {id_category: params?.id_category ?? defaultCategory};
        }

        // commit in our case just returns the data to the caller. No server interaction.
        // data already contains the toJSON()'d data members
        async save(data) {
            var result = await api.save(data);            
            await list.reload(); // reload the list of activity types, so that the new one is available in the combo
            this.fill(result.data);
        }
    }

    let dlg = ref (new DialogModelActivityType( { 
        modelName: "activitytype",         
        dlgTitle: "Activiteitstype",
        forms: form, 
        icon: 'tasks', 
        saveText: 'Ga door',
        useDirtyCheck: true,
        keepOpen: false,
    }));
    
</script>